import yup from "../utility/ValidationUtilty";

export type Consent = {
  id: string;
  appType: 'mobile' | 'staff';
  type: 'termsOfServices' | 'privacyPolicy';
  title: string;
  text: string;
  version: string;
  updateAt: Date;
}

export const consentTimestampToDate = (data: any | undefined): Consent => {
  data.updateAt = new Date(data?.updateAt.seconds * 1000);
  return data;
}

const semverRegex = /^(\d+)\.(\d+)\.(\d+)$/;

export const consentSchema = yup.object({
  // バージョン
  version: yup
    .string()
    .required()
    .matches(semverRegex, '0.0.0 の形式で入力してください。'),
  // タイトル
  title: yup.string().required(),
  // 本文
  text: yup.string().required()
});